import Navigation from "./modules/Navigation";
import Carousels from "./modules/Carousels";
import {Accordion} from "./modules/Accordion";
import SimpleLightbox from "simplelightbox";

const galleryLightbox = () => {
    new SimpleLightbox('.simple-lightbox', {showCounter: false, history: false});
}

galleryLightbox();

new Navigation();
new Carousels();
Accordion();
